import { PrismicNextImage, PrismicNextImageProps } from '@prismicio/next';

export const OptimizedPrismicImage = ({
  field,
  className,
  ...restProps
}: PrismicNextImageProps) => {
  return (
    <PrismicNextImage
      priority
      className={className}
      field={field}
      imgixParams={{
        q: 75,
      }}
      {...restProps}
    />
  );
};
